<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vue Monica Refine Design
      Author: Riyan Kurniawan
    -- MONICA --
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img">
    <div
      id="data-list-list-view"
      class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center data-list-container vs-con-loading__container">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col lg:w-1/2 mx-auto self-center">
              <img
                src="@/assets/images/pages/reset-password.png"
                alt="login"
                class="mx-auto" />
            </div>
            <div class="vx-col lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8" v-if="activate_success">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">
                    Dear {{ name }} Your Account is Activated
                  </h4>
                  <p>Please enter your new password.</p>
                </div>
                <vs-input
                  type="password"
                  label-placeholder="Password"
                  v-model="password"
                  class="w-full mb-6 btn-load-1 vs-con-loading__container" />
                <vs-input
                  type="password"
                  label-placeholder="Confirm Password"
                  v-model="confirm_password"
                  class="w-full mb-8" />

                <div
                  class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                  <vs-button class="w-full sm:w-auto" @click="activate()"
                    >Submit</vs-button
                  >
                </div>
              </div>
              <div class="p-8" v-if="!activate_success">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Activate Failed</h4>
                  <p>Your Token is Expired or Link is Incorect.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import * as REPO from '../../../repository/index'

export default {
  data() {
    return {
      id: '',
      activate_success: false,
      password: '',
      name: '',
      confirm_password: '',
    }
  },
  mounted() {
    this.$vs.loading({
      container: '#data-list-list-view',
      scale: 1,
    })
    let id = this.$route.params.id
    REPO.getActivateUser(id)
      .then((res) => {
        this.name = res.data.data.name
        this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        if (res.data.status == 'true') {
          this.activate_success = true
        } else {
          this.activate_success = false
          this.$toast.error(res.data.error_msg)
        }
      })
      .catch((err) => {
        this.activate_success = false
        this.$toast.error(err.message)
      })
  },
  methods: {
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    activate() {
      let id = this.$route.params.id
      if (this.password === this.confirm_password && this.password !== '') {
        this.loadingBtnStart('btn-load-1')
        let dataForm = {
          password: this.password,
          confirm_password: this.confirm_password,
          is_active: 1,
        }
        REPO.activateUser(dataForm, id)
          .then((res) => {
            this.loadingBtnStop('btn-load-1')
            if (res.data.status == 'true') {
              this.$emit('submitModal', false)
              this.$toast.success('User Successfully Activated, Please Login')

              setTimeout(() => {
                this.$router.push('/pages/login')
              }, 2000)
            } else {
              this.$toast.error(res.data.error_msg)
            }
          })
          .catch((err) => {
            this.loadingBtnStop('btn-load-1')
            //
            this.$toast.error(err.message)
          })
      } else {
        this.$toast.error('Confirm Password Not Same as Password')
      }
    },
  },
}
</script>
